import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataActiveInfoType } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { ISODate } from '../../common/utils';
import { InputDataActiveInfoSchema } from '../schema/InputDataSchema';

export interface InputDataActiveInfoParams {
  groupId: number;
  valueDate: ISODate;
}

const getInputDataActiveInfo = (params?: InputDataActiveInfoParams) =>
  apiClient
    .get<InputDataActiveInfoType>(
      expand(InputDataUrl.INPUT_DATA_ACTIVE, params)
    )
    .then((response) => InputDataActiveInfoSchema.parse(response.data));

export const useInputDataActiveInfoQuery = createApiQueryHook(
  ['inputDataActiveInfo'],
  getInputDataActiveInfo
);
